import React from "react";
import { getIpoListData } from "../../services/TradingMallService";
import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";
import { MAINBOARD, SME } from "../IpoList/IpoListConstants";
import type { IIpoListAPIResponse } from "../../interfaces/IpoList.interface";

interface BaseIpoServerWrapperProps {
  authoringData?: IpoAuthoringDataType;
  defaultIpoType: string;
  renderClient: (
    mainboardInitial: IIpoListAPIResponse,
    smeInitial: IIpoListAPIResponse,
  ) => React.ReactNode;
}

const IpoBaseServerWrapper = async ({
  authoringData = {},
  defaultIpoType,
  renderClient,
}: BaseIpoServerWrapperProps) => {
  const parsedPaginationLimit = Number.parseInt(
    authoringData?.paginationLimit ?? "20",
    10,
  );

  const paginationLimit =
    Number.isFinite(parsedPaginationLimit) && parsedPaginationLimit > 0
      ? parsedPaginationLimit
      : 20;

  const [mainboardInitial, smeInitial] = await Promise.all([
    getIpoListData({
      ipoType: authoringData?.ipoType ?? defaultIpoType,
      limit: paginationLimit,
      page: 1,
      subType: MAINBOARD,
    }),
    getIpoListData({
      ipoType: authoringData?.ipoType ?? defaultIpoType,
      limit: paginationLimit,
      page: 1,
      subType: SME,
    }),
  ]);

  return (
    <section className="flex flex-col gap-[12px] pb-[12px] pl-[16px] pr-[16px] pt-[12px] lg:pl-[144px] lg:pt-[24px]">
      {renderClient(mainboardInitial, smeInitial)}
    </section>
  );
};

export default IpoBaseServerWrapper;
